import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { DataEventProps } from "../../../../libraries/wpl/foundations/src/index";
import { Button } from "../../../wpl/button/src/index";

import BannerBody from "./banner-body";
import BannerTitle from "./banner-title";

export type BannerProps = {
    title: string;
    body: string;
    linkText: string;
    linkUrl: string;
    dataEventProps: DataEventProps;
};

export const Banner = ({
    title,
    body,
    linkText,
    linkUrl,
    dataEventProps
}: BannerProps) => {
    const bannerStyle = css({
        boxSizing: "border-box",
        containerType: "inline-size",
        display: "flex",
        flexFlow: "row wrap",
        justifyContent: "space-between",
        alignItems: "center",
        alignContent: "stretch",
        margin: 0,
        padding: token("space.250"),
        width: "100%",
        fontSize: token("space.200"),
        color: "#42526e",
        background: "#e6fcff",
        borderRadius: "3px"
    });

    const bannerLeftStyle = css({
        width: "66.66%",
        display: "flex",
        flexFlow: "column wrap",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        alignContent: "center"
    });

    const bannerRightStyle = css({
        [media.above.sm]: {
            paddingInlineStart: token("space.100")
        },
        [media.below.sm]: {
            flexBasis: "100%",
            marginBlockStart: token("space.250")
        },
        display: "flex",
        justifyContent: "flex-end"
    });

    const buttonStyle = css({
        [media.below.sm]: {
            flexBasis: "100%"
        },
        "fontSize": token("space.200"),
        "fontWeight": "normal",
        ":hover, :focus, :active": {
            background: "transparent"
        }
    });

    return (
        <div css={bannerStyle}>
            <div css={bannerLeftStyle}>
                <BannerTitle>{title}</BannerTitle>
                <BannerBody>{body}</BannerBody>
            </div>
            <div css={bannerRightStyle}>
                <Button
                    css={buttonStyle}
                    text={linkText}
                    url={linkUrl}
                    type="secondary"
                    dataEventProps={dataEventProps}
                />
            </div>
        </div>
    );
};
